<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							required
							v-model="$v.model.name.$model"
							:error="$v.model.name.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Código"
							:disabled="codeAppDisabled"
							:readonly="codeAppDisabled"
							required
							v-model="$v.model.codeApp.$model"
							:error="$v.model.codeApp.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Url Repositorio en github"
							required
							v-model="$v.model.repo.$model"
							:error="$v.model.repo.$error"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const PAGE_APP_LIST = 'page-app';

function data() {
	return {
		countries: [],
		loading: false,
		model: {
			codeApp: '',
			codeProject: '',
			name: '',
			repo: '',
		},
	};
}

async function created() {
	if (this.mode === 'edit') {
		const { data: record } = await this.$http.get(`app/${this.appId}`);
		if (record.data) {
			this.model = {
				name: record.data.name,
				codeApp: record.data.codeApp,
				repo: record.data.repo,
			};
		}
	}
	this.model.codeProject = this.codeProject;
}

function closeModal() {
	this.goTo(PAGE_APP_LIST);
}

function codeAppDisabled() {
	return !!this.appId && !!this.$v.model.codeApp.$model;
}

function mode() {
	return this.appId ? 'edit' : 'create';
}

async function submitForm() {
	const method = this.mode === 'create' ? 'post' : 'put';
	const url = this.mode === 'create' ? 'app' : `app/${this.appId}`;
	this.loading = true;
	try {
		await this.$http[method](url, this.model);
		this.goTo(PAGE_APP_LIST);
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
			codeApp: {
				required,
			},
			codeProject: {
				required,
			},
			repo: {
				required,
			},
		},
	};
	return validation;
}

export default {
	name: 'apps-form',
	created,
	computed: {
		codeAppDisabled,
		mode,
	},
	data,
	methods: {
		closeModal,
		submitForm,
	},
	props: {
		appId: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
			required: true,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/apps/app-form.vue